import angular from "angular";
import Vue from "vue";
import "ngVue";
import DocumentSigningView from "../../components/DocumentSigningView.vue";
import SignatureModal from "../../components/SignatureModal.vue";
import FieldModal from "../../components/FieldModal.vue";
import SignatureStatusBadge from "../../components/SignatureStatusBadge.vue";
import PendingFieldsPanel from "../../components/PendingFieldsPanel.vue";
import SignatureHistoryList from "../../components/SignatureHistoryList.vue";
import DocumentFieldProgress from "../../components/DocumentFieldProgress.vue";
import VueSignaturePad from "vue-signature-pad";

// Install vue-signature-pad
Vue.use(VueSignaturePad);

// Register all Vue components globally
Vue.component("SignatureModal", SignatureModal);
Vue.component("FieldModal", FieldModal);
Vue.component("SignatureStatusBadge", SignatureStatusBadge);
Vue.component("PendingFieldsPanel", PendingFieldsPanel);
Vue.component("SignatureHistoryList", SignatureHistoryList);
Vue.component("DocumentFieldProgress", DocumentFieldProgress);
Vue.component("DocumentSigningView", DocumentSigningView);

export default angular
  .module("common.directives.documentSigningView", [])
  .directive("documentSigningView", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DocumentSigningView"));
    },
  ]);
